import { useInfiniteQuery } from '@tanstack/react-query';

import { accountsQueries } from '../utils/queries';
import { setMinimalPromiseTime } from 'src/common/utils/setMinimalPromiseTime';

import { useMemo } from 'react';
import { fetchAccounts } from '../api/accounts';

const ACCOUNTS_PAGE_SIZE = 100;

export const useInfinityAccountsQuery = (
  searchText: string,
  options?: { enabled?: boolean; minTime?: number },
) => {
  const enabled = options?.enabled ?? true;
  const minTime = options?.minTime ?? 0;

  const { data, ...queryProps } = useInfiniteQuery({
    queryKey: accountsQueries.infinityList({ search: searchText, pageSize: ACCOUNTS_PAGE_SIZE }),
    queryFn: async ({ pageParam }) => {
      if (minTime > 0) {
        return setMinimalPromiseTime(
          fetchAccounts({
            search: searchText,
            pageSize: ACCOUNTS_PAGE_SIZE,
            pageNumber: pageParam,
          }),
          minTime,
        );
      }

      return fetchAccounts({
        search: searchText,
        pageSize: ACCOUNTS_PAGE_SIZE,
        pageNumber: pageParam,
      });
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage, pages) => {
      if (lastPage.length >= ACCOUNTS_PAGE_SIZE) {
        return pages.length + 1;
      }
    },

    enabled,
  });

  const accounts = useMemo(
    () =>
      data?.pages.reduce((acc, value) => {
        return [...acc, ...value];
      }, []) || [],
    [data],
  );

  return {
    accounts,
    ...queryProps,
  };
};
